<template>
    <button class="mx-1" :class="buttonClasses"  @click="onButtonClick" style="min-width: 120px;">
        {{component.value}}
    </button>
</template>

<script>
    export default {
        name: 'BackButton',
        props: ['component', 'cssFramework'],
        computed: {
            buttonClasses() {
                if(this.cssFramework === 'Tailwind') {
                    return 'px-4 py-2 border rounded border-zinc-200 shadow-md hover:bg-zinc-100'
                }

                return `btn btn-${this.buttonTheme}`
            },
            buttonTheme() {
                return this.component.style && this.component.style.color ? this.component.style.color : 'secondary'
            }
        },
        data () {
            return {
                model: webase.model
            }
        },
        mounted () {
        },
        methods: {
            onButtonClick () {
                this.$router.go(-1)
            }
        }
    }
</script>

<style>

</style>
